// extracted by mini-css-extract-plugin
export default {"frosted":"Dashboard_frosted__Yabys","surveyTemplateContainer":"Dashboard_surveyTemplateContainer__5J4FE"};